
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sezione-ragazzi/[slug]",
      function () {
        return require("private-next-pages/sezione-ragazzi/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sezione-ragazzi/[slug]"])
      });
    }
  